import { styled } from 'styled-components';
export const MenuBrandContainer = styled.div.withConfig({
  displayName: "MenuLogostyle__MenuBrandContainer",
  componentId: "sc-p676lx-0"
})(["", " img{", "}.mobile{", "}@media (max-width:", "){", " .desktop{", "}.mobile{", "}}"], {
  "display": "flex",
  "width": "11rem",
  "cursor": "pointer",
  "alignItems": "center"
}, {
  "objectFit": "contain"
}, {
  "display": "none"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "width": "auto"
}, {
  "display": "none"
}, {
  "display": "block",
  "aspectRatio": "1 / 1",
  "height": "100%",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem"
});